<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
.source-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 32px;
  color: #111111;
  font-weight: 400;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 32px;
  background-color: #fff;

  .source-desc {
    margin: 26px 0 24px;
    color: #999999;
    font-weight: 400;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 36px;
  }

  .more-source {
    position: relative;
    display: inline-block;
    width: 100%;
    margin-top: 48px;
    color: #111111;
    font-weight: 300;
    font-size: 24px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 24px;
    text-align: center;

    &::after {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 96px;
      height: 1px;
      margin-bottom: -4px;
      margin-left: -48px;
      background: #111111;
      content: '';
    }
  }
  /deep/ .video .video-item {
    border-radius: 16px;
  }
}
.no-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 32px;
  .no-icon-margin {
    margin-top: 32px;
  }
}

.new-source-content {
  .title-info {
    height: 40px;
    .more-title {
      position: relative;
      display: inline-block;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      line-height: 28px;

      &::after {
        @include hairline(#111111);
        border-bottom-width: 1px;
      }
    }
  }
  .source-desc {
    margin: 20px 0;
    font-family: PingFangSC-Light, PingFang SC;
  }

  /deep/ .video .video-item {
    border-radius: 24px;
  }
}
</style>

<template>
  <section
    v-if="hasSourceInfo"
    v-zpm="{ areaexposure: 130 }"
    class="source-content new-source-content"
    :class="[!sourceInfo.titleIcon ? 'no-icon' : '']"
  >
    <z-biz-video
      v-if="sourceInfo.videoUrl"
      ref="refVideo"
      v-zpm="{
        sectionid: 130,
        sortname: '视频点击',
        sortid: 1
      }"
      class="video"
      :video-url="sourceInfo.videoUrl"
      :pic-url="sourceInfo.videoImg"
      :px2rem="true"
      width="686"
      height="388"
      :auto="false"
      :wifi-auto="false"
      :mute-btn="false"
      :playPauseWithTimer="false"
    />
    <span class="more-source" @click="goBSMore">更多货源</span>
  </section>
</template>
<script>
import Vue from 'vue'
import { skipToUrl } from '@utils/native'
import { defineComponent, onMounted, ref, computed, watch } from '@vue/composition-api'
import { Icon, BizVideo } from '@zz-common/zz-ui'
import { getQueryString } from '@utils/index'
Vue.use(Icon).use(BizVideo)
export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    visibilityState: {
      type: String,
      default: ''
    }
  },
  components: {},
  setup(props, ctx) {
    const { $tiktok, $legoAreaExposure } = ctx.root
    $tiktok('created', 'source-info')
    const refVideo = ref(null)
    const videoStatus = ref(false)

    const hasSourceInfo = computed(() => {
      return (
        props.dataInfo &&
        props.dataInfo.sourceInfo &&
        Object.values(props.dataInfo).length &&
        props.dataInfo.sourceInfo.jumpUrl
      )
    })

    const sourceInfo = computed(() => {
      return props.dataInfo.sourceInfo
    })

    const goBSMore = () => {
      skipToUrl({
        targetUrl: sourceInfo.value.jumpUrl
      })
    }

    onMounted(() => {
      $tiktok('mounted', 'source-info')
      $legoAreaExposure()
    })

    watch(refVideo, (val) => {
      if (val) {
        refVideo.value.$refs.video.muted = false
      }
    })

    watch(
      () => props.visibilityState,
      (val) => {
        if (refVideo.value) {
          if (val === 'hidden') {
            try {
              refVideo.value.$refs.video.pause()
            } catch (error) {
              console.log(error)
            }
          }
        }
      }
    )

    return {
      hasSourceInfo,
      sourceInfo,
      goBSMore,
      videoStatus,
      refVideo,
      getQueryString
    }
  }
})
</script>
